import { IntegrationKey } from '@erp/rpc';
import { useListIntegrations } from 'src/api/rpc/hooks/integrations/useIntegrations';

/**
 * Whether Slack system events should be offered in workflow trigger
 * pickers: the Slack integration must be installed for this org AND the
 * backend must report it as available (env-configured). Mirrors the
 * backend's webhook receiver gate.
 */
export function useSlackEventsEnabled(): boolean {
  const { data } = useListIntegrations();
  const installed = Boolean(data?.installed?.[IntegrationKey.Slack]);
  const available = data?.availability?.[IntegrationKey.Slack]?.available;
  return installed && available !== false;
}
